import AttentionSVG from './attention.svg';
import withIconProps from './withIconProps';

export default withIconProps(AttentionSVG);
